import { classNames } from "@/react/helpers/twMergeWithCN";
import { SkeletonLoader } from "@circle-react-shared/uikit/SkeletonLoader";
import { TiptapBuilderPreviewContent } from "./TiptapBuilderPreviewContent";
import { VisualBuilderPreviewContent } from "./VisualBuilderPreviewContent";
import { useBroadcastPreviewContent } from "./useBroadcastPreviewContent";

export const PreviewContent = () => {
  const {
    isLoading,
    emailContent,
    visualEmailBuilderContentHtml,
    emailContentType,
  } = useBroadcastPreviewContent();

  const hasNoContent = !(emailContent || visualEmailBuilderContentHtml);

  const shouldShowSkeleton = isLoading || hasNoContent;

  const renderContent = () => {
    if (emailContentType === "tip_tap_email")
      return <TiptapBuilderPreviewContent />;
    if (emailContentType === "visual_email_builder")
      return <VisualBuilderPreviewContent />;
    if (shouldShowSkeleton) return <SkeletonLoader variant="email-preview" />;

    return null;
  };

  return (
    <div className="bg-tertiary overflow-y-auto py-12 shadow-sm">
      <div
        className={classNames(
          "bg-primary mx-auto min-h-[420px] rounded-lg lg:w-[600px]",
          {
            "p-8": !visualEmailBuilderContentHtml,
            "h-full": hasNoContent,
            "bg-white": visualEmailBuilderContentHtml,
          },
        )}
      >
        {renderContent()}
      </div>
    </div>
  );
};
